import React from 'react';
import { Chip, Tooltip } from '@mui/material';
const RecordCitationChip = ({
  docId,
  chunkIndex,
  memberId,
  datasetName,
  onOpen,
}) => {
  if (!docId) return null;

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (onOpen) {
      onOpen({
        docId,
        chunkIndex,
        memberId,
        datasetName,
      });
    }
  };

  const marker = chunkIndex !== undefined && chunkIndex !== null ? `[${chunkIndex}]` : '[record]';

  return (
    <Tooltip title={`${docId}.json${chunkIndex !== undefined ? `, chunk ${chunkIndex}` : ''}`}>
      <Chip
        label={marker}
        size="small"
        onClick={handleClick}
        className="record-citation-chip"
        aria-label={`Open record citation ${docId}${chunkIndex !== undefined ? ` chunk ${chunkIndex}` : ''}`}
      />
    </Tooltip>
  );
};

export default RecordCitationChip;
